import { render, staticRenderFns } from "./RenameRelationGroup.vue?vue&type=template&id=1fd1d437"
import script from "./RenameRelationGroup.vue?vue&type=script&lang=js"
export * from "./RenameRelationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports